import { z } from 'zod';

export const copilotActionSchema = z.object({
  description: z.string().min(1),
  message: z.string().min(1),
  impactLevel: z.number(),
});

export const copilotActionsSchema = z.array(copilotActionSchema);

export type CopilotAction = z.infer<typeof copilotActionSchema>;

export type CopilotActions = z.infer<typeof copilotActionsSchema>;
